import Component from '../component'
import { connect } from 'react-redux'
import { login, message, errorClosed, goToLobby } from '../../redux/actions'
import { t } from 'i18next'

/**
 * A message which lets the user log in again
 * when the session has timed out.
 */
@connect(state => ({ moneymode: state.session.moneymode }), { login, message, errorClosed, goToLobby })
export default class MessageWithLogin extends Component {
  /**
   * Attempt to log in, and close the error.
   * @param {object} e - Button event.
   */
  login = (e) => {
    const { errorCode } = this.props
    this.props.login()
    this.props.errorClosed({ errorCode })
    this.props.message(null)
    e.preventDefault()
  }

  /**
   * Closes the message and redirect player to lobby
   * @param {object} e - Button event
   * @returns {boolean}
   */
  homeAction = (e) => {
    this.props.goToLobby()
    e.preventDefault()
  }

  /**
   * Renders out a DOM element, displaying a button that lets the user log in.
   * @returns {*}
   */
  render() {
    const { errorCode, mess, moneymode } = this.props
    const keyString = `error.${errorCode}`
    const translation = t(keyString)
    const displayText = translation !== keyString ? translation : mess
    return (
      <div className="popup-content">
        <div className="popup-message">
          {displayText}
        </div>
        <br />
        <div className="buttonContainer">
          { moneymode === 'fun' ? (
            <button onClick={this.login}>Log-in</button>
          ) : (
            <button onClick={this.homeAction}>{t('realityCheck.cancel')}</button>
          )}
        </div>
      </div>
    )
  }
}
